import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Icon, Loader } from 'semantic-ui-react';

class Pagination extends Component {
  render() {
    const {
      start,
      end,
      nextHandler,
      previousHandler,
      loading,
      lastPage,
      pageSize,
    } = this.props;

    return (
      <div data-testid='pagination' style={{ float: 'right', margin: '1em 0' }}>
        {loading && (
          <Loader active inline size='mini'>
            Loading...
          </Loader>
        )}
        {!loading && (
          <div>
            <span>
              Showing{' '}
              <b data-testid='pagination-range'>
                {start} - {end}
              </b>&nbsp;&nbsp;
            </span>
            <Button
              data-testid='pagination-prev'
              icon
              color='green'
              inverted
              disabled={start <= 1}
              onClick={previousHandler}
            >
              <Icon name='caret left' />
            </Button>
            <Button
              data-testid='pagination-next'
              icon
              color='green'
              inverted
              disabled={lastPage || end < pageSize}
              onClick={nextHandler}
            >
              <Icon name='caret right' />
            </Button>
            <br />
            {lastPage && <span>No more rows</span>}
          </div>
        )}
      </div>
    );
  }
}

Pagination.propTypes = {
  start: PropTypes.number,
  end: PropTypes.number,
  nextHandler: PropTypes.func,
  previousHandler: PropTypes.func,
  loading: PropTypes.bool,
  lastPage: PropTypes.bool,
  pageSize: PropTypes.number,
};

export default Pagination;
